export default __webpack_public_path__ + "static/media/ribboncuttin_w640.ec7cc67b.jpeg";